import { render, staticRenderFns } from "./chooseBatch.vue?vue&type=template&id=008f7003&"
import script from "@viewJs/excuseExam/chooseBatch.js?vue&type=script&lang=js&"
export * from "@viewJs/excuseExam/chooseBatch.js?vue&type=script&lang=js&"
import style0 from "./chooseBatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports